import React from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaBriefcase, FaClipboardCheck } from "react-icons/fa";
import { FaLinkedin, FaTwitter, FaFacebook, FaEnvelope } from "react-icons/fa";
import Footer from "../../components/Home/footer/Footer";
const JobListView = () => {
  return (
    <>
      <section className='job-View'>
        <div className='row align-items-center bg-white p-5'>
          <div className='col-md-9'>
            <h2 className='text-black'>
              2024 Brand Specialist (e-Commerce) Intern
            </h2>
            <div className='mb-4 flex flex-row'>
              <p> Job ID: 2652639 |</p>{" "}
              <p> Amazon Commercial Services Pty Ltd </p>
            </div>
            <Link
              to='/carrer/sign-in'
              className='rounded px-5 py-3 text-white'
              style={{ backgroundColor: "#0095D9" }}
            >
              Apply Now
            </Link>
          </div>
          <div className='col-md-3'>
            <img
              src='https://s3-alpha-sig.figma.com/img/79ad/d9a6/5d3951bdb9a23d5032100ac5af0ce11a?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=qgk7eQ~hXx9jKuxJEjzobPmml9lhY2wDdxbUCujuy5jn25x4~tcKjcaN1aPN7rL4v9kMsTzdZRQaKYHvK74n~wkAyMwRJX65i2NuqSAY-jb8gKzr1fV-dRWz9uejLYSrAPSOzrfKM9tuRCqpCJoExu3t3Js1qAxLk5ByzO8BlATFFqp~gS-XtDopkRTqJ~SjGwZybbMU3Iu7gaTQ1RuYI4tiIjrLPF06pOvgZQhSkxGN7m~GNGlRfCLMMmPEgWuzUE1-yXHukrgHfIeoDO7QDkJZm8j1Ri7c8siMmrKkApdCH0OLgXJR8bQmgC0cMOWPisQOrXEoGARKHW2-ZtCZMQ__'
              alt=''
              srcset=''
              className='w-100 h-100'
            />
          </div>
        </div>
      </section>
      <section className='mb-5'>
        <div className='jobView container mt-5'>
          <div className='row'>
            <div className='col-md-9'>
              <div>
                <h1 className='mb-4'>DESCRIPTION</h1>
                <ul
                  className='list-unstyled'
                  style={{ listStyleType: "disc", paddingLeft: "20px" }}
                >
                  <li>
                    Work alongside our Brand Specialists to learn what they do,
                    and gain exposure to the breadth that Amazon has to offer.
                    This includes learning about our major functional areas,
                    Vendor Management (ownership of a P&L), In-stock management
                    (supply chain), and content management (marketing).
                  </li>
                  <li>
                    Own and deliver a project which is impactful to an entire
                    category or department. You will have full ownership of your
                    deliverable, which will have tangible results to the
                    Australia Business.
                  </li>
                  <li>
                    Work across categories such as Books, Fashion, Electronics,
                    Toys, Video Games, Health & Beauty, and everything in
                    between, learning how Amazon manages and grows its
                    e-commerce retail business, and develop the analytical and
                    problem-solving skills that our people are known for.
                  </li>
                  <li>
                    Delivering an impactful project: You will be responsible for
                    delivering a strategically important project for Australia.
                    You will be supported in delivering this with a Mentor,
                    Buddy and Manager. Example projects completed by previous
                    interns are:
                    <ul
                      className='list-unstyled my-2'
                      style={{ listStyleType: "disc", paddingLeft: "20px" }}
                    >
                      <li>
                        Revamping the end-to-end process for New Releases in
                        Media;
                      </li>
                      <li>
                        Establishing an AU wide resource repository for deal
                        events such as Prime Day and Black Friday;
                      </li>
                      <li>
                        Analyzing large data sets to assess performance of
                        Amazon initiatives;
                      </li>
                      <li>
                        Deep diving the product creation process to create a new
                        way of working;
                      </li>
                      <li>
                        Creating pitch materials to enable senior leaders to
                        successfully pitch the AVS service.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Experiencing the Brand Specialist role: This could include
                    creating Joint Business Plans with Vendors, identifying and
                    exciting strategies to drive new selection, marketing
                    management, price promotions, operational efficiencies and
                    reporting analysis. Many of our Interns return to join us
                    full time as Brand Specialist, check out our Day in the life
                    of a Brand Specialist from around the world :
                    <a className='ms-1' href='https://youtu.be/fYaySG_trNY'>
                      https://youtu.be/fYaySG_trNY
                    </a>
                  </li>
                  <li>
                    Learning and development: You will engage in a calendar of
                    events designed to develop your transferable skills, learn
                    the peculiar culture of Amazon, develop an understanding of
                    what we do, and network with Business leaders.
                  </li>
                  <li>
                    About the team <br />
                    The Brand Specialists Amazon Vendor Services (AVS) team work
                    directly with our strategic e-commerce vendors drive
                    business growth and maximise their potential on Amazon. Our
                    job is to actively develop the customer experience and we do
                    this by working closely with our brand partners, and
                    collaborating internally with key retail functions such as
                    supply chain, marketing and buying teams.
                  </li>
                  <li>
                    We are open to hiring candidates to work out of one of the
                    following locations:
                  </li>
                  <li>Sydney, NSW, AUS</li>
                </ul>
                <h1 className='mb-4 mt-5'>BASIC QUALIFICATIONS</h1>
                <ul
                  className='list-unstyled'
                  style={{ listStyleType: "disc", paddingLeft: "20px" }}
                >
                  <li className='mb-2'>
                    Open to candidates from all disciplines in the penultimate
                    year of their degree.
                  </li>
                  <li className='mb-2'>
                    A natural appetite for learning and the ability to pick up
                    new skills quickly.
                  </li>
                  <li className='mb-2'>
                    Strong analytical, relationship management and
                    organizational skills.
                  </li>
                  <li className='mb-2'>
                    A focus on identifying problems and creating solutions!
                  </li>
                  <li className='mb-2'>
                    Exceptional communication skills with an ability building
                    positive working relationships.
                  </li>
                  <li className='mb-2'>
                    Drive to deliver results in an ambiguous environment, being
                    exceptionally detail orientated while looking around corners
                    and thinking bigger about how we create a compelling
                    customer offer.
                  </li>
                  <li>
                    Please note: To be eligible for this program you will need
                    to be available for the full internship period from early
                    December 2024 to mid/late February 2025.
                  </li>
                  <li>
                    This role is based and in Sydney and will require the
                    commitment of successful candidates to be based in Sydney
                    for the duration of the internship. For those not based in
                    Sydney, it may mean relocating at own cost.
                  </li>
                </ul>
                <h3>Applications and Assessment Process</h3>
                <ul
                  className='list-unstyled'
                  style={{ listStyleType: "disc", paddingLeft: "20px" }}
                >
                  <li className='mb-2'>
                    All candidates will be invited to complete an online
                    assessment which we encourage you to complete within 5
                    business days. Your application will then be reviewed for
                    suitability for the role. If successful, you will be invited
                    to attend a phone interview follow by two virtual
                    interviews, focusing on our Leadership Principles. If you
                    have a disability and need an adjustment during the
                    application and hiring process, including support for the
                    interview or onboarding process, please email us
                    (anzcampus@amazon.com.au) and put Applicant–Candidate
                    Accommodation Request in the subject line for expedited
                    processing.
                  </li>{" "}
                  <li>
                    Have any questions? Please contact us at
                    (anzcampus@amazon.com.au)
                  </li>
                  <li>
                    Note: Applications are reviewed on a rolling basis. For an
                    update on your status, or to confirm your application was
                    submitted successfully, please login to your candidate
                    portal. Please note that we are reviewing a high volume of
                    applications and appreciate your patience.
                  </li>
                  <li>
                    Have a question? Please click on the below link to view our
                    FAQs document:{" "}
                    <a href='https://amazonexteu.qualtrics.com/CP/File.php?F=F_ctP17e4M4BpNiZ6'>
                      FAQ document link
                    </a>
                  </li>
                  <li>
                    If you have any other questions not answered in the FAQs,
                    please feel free to contact us at anzcampus@amazon.com.au
                  </li>
                  <li>
                    Acknowledgement of country: In the spirit of reconciliation
                    Amazon acknowledges the Traditional Custodians of country
                    throughout Australia and their connections to land, sea and
                    community. We pay our respect to their elders past and
                    present and extend that respect to all Aboriginal and Torres
                    Strait Islander peoples today.
                  </li>
                  <li>
                    IDE statement: Amazon is committed to a diverse and
                    inclusive workplace. Amazon is an equal opportunity employer
                    and does not discriminate on the basis of race, national
                    origin, gender, gender identity, sexual orientation,
                    disability, age, or other legally protected attributes.
                  </li>
                </ul>
              </div>
            </div>

            <div className='col-md-3'>
              <div className='job-details'>
                <h3 className='bottom-border'>Job details</h3>
                <div className='location d-flex align-items-baseline bottom-border gap-3'>
                  <FaMapMarkerAlt style={{ color: "#0095D9" }} /> AUS, NSW,
                  Sydney
                </div>
                <div className='internships d-flex align-items-baseline bottom-border gap-3'>
                  <FaBriefcase style={{ color: "#0095D9" }} /> Internships for
                  students
                </div>
                <div className='management d-flex align-items-baseline bottom-border gap-3'>
                  <FaClipboardCheck style={{ color: "#0095D9" }} /> Buying,
                  Planning, & Instock Management
                </div>
              </div>

              <div className='related-jobs'>
                <h3 className='bottom-border'>Related Jobs</h3>
                <div className='job bottom-border'>
                  <h4 style={{ color: "#0095D9" }}>
                    2025 Graduate Brand Analyst
                  </h4>
                  <p>Location: AUS, NSW, Sydney</p>
                  <p>Posted: February 24, 2024</p>
                  <p>(Updated about 1 hour ago)</p>
                </div>
                <div className='job bottom-border'>
                  <h4 style={{ color: "#0095D9" }}>
                    2024 Graduate Brand Analyst
                  </h4>
                  <p>Location: AUS, NSW, Sydney</p>
                  <p>Posted: February 24, 2024</p>
                  <p>(Updated about 1 hour ago)</p>
                </div>
                <div className='job bottom-border'>
                  <h4 style={{ color: "#0095D9" }}>
                    Sr. Procurement Category Manager
                  </h4>
                  <p>Location: AUS, NSW, Sydney</p>
                  <p>Posted: February 24, 2024</p>
                  <p>(Updated about 1 hour ago)</p>
                </div>
                <div className='job bottom-border'>
                  <h4 style={{ color: "#0095D9" }}>Senior Category Manager</h4>
                  <p>Location: AUS, NSW, Sydney</p>
                  <p>Posted: February 24, 2024</p>
                  <p>(Updated about 1 hour ago)</p>
                </div>
                <div className='job bottom-border'>
                  <h4 style={{ color: "#0095D9" }}>Category Growth Manager</h4>
                  <p>Location: AUS, NSW, Sydney</p>
                  <p>Posted: February 24, 2024</p>
                  <p>(Updated about 1 hour ago)</p>
                </div>
              </div>

              <div className='share-job'>
                <h3>Share this job</h3>
                <div className='social-icons'>
                  <FaLinkedin /> <FaTwitter /> <FaFacebook /> <FaEnvelope />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default JobListView;
